"use client";

import { useEffect, useRef, type ReactNode } from "react";
import cn from "clsx";
import styles from "./CareerServiceBanner.module.scss"
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { statCards } from "./utils";
import { UnivoCarouselSettings } from "@/components/common";
import useOnScreen from "@/helpers/Onscreen";

interface HeroSectionHomeNewProps {
  isMobile?: boolean;
  lcpMedia?: ReactNode;
  associatedPrograms?:any
}

const HeroHeading: React.FC = () => (
  <h1 className={styles.heroHeading}>
    EMPOWERING <br />
    EVERY STEP OF <br />
    <span className={styles.highlightYellow}>YOUR CAREER JOURNEY</span>
  </h1>
);

const HeroDescription: React.FC = () => (
  <p className={styles.heroDescription}>
    From career planning to interview success, get the guidance, tools, and support you need to confidently step into the professional world
  </p>
);


export const HeroSectionCareerServices: React.FC<HeroSectionHomeNewProps> = ({
  isMobile = false,associatedPrograms
}) => {
    const modalDispatch = useModalDispatch();

    const handleBtnClicked = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalV2,
        modalData: {
          heading: "Get career guidance designed for your goals",
          submitBtnText: "Book a Free Session",
          associatedPrograms,
          isLandingPage: true,
        },
      },
    });
    }
    const ref = useRef(null)
    const onScreen = useOnScreen(ref)

    useEffect(()=>{
      const applyDisplay = (el: HTMLElement) => {
        el.style.display = onScreen ? "none" : "block";
      };

      const existingRef = document.getElementById('enroll-now-cta');
      if (existingRef) {
        applyDisplay(existingRef);
        return;
      }

      // EnrollNowSticky mounts lazily (dynamic import, ssr: false, behind a
      // Suspense boundary), so it may not exist in the DOM on the first run.
      // Watch for it and apply the current state once it actually mounts.
      const observer = new MutationObserver(() => {
        const enrollNowRef = document.getElementById('enroll-now-cta');
        if (enrollNowRef) {
          applyDisplay(enrollNowRef);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      return () => observer.disconnect();
    }, [onScreen])
  return (
    <section className={styles.heroSection} data-section="career-hero">
      <div className={styles.heroContainer}>
        <div className={styles.heroContentWrapper}>
          <div className={styles.heroContent}>
            <div>
            <HeroHeading />
            <HeroDescription />
            </div>
            <button ref={ref} onClick={handleBtnClicked} className={styles.ctaButton}>
            Schedule 1:1 Career Counseling →
          </button>
          </div>
        </div>
      </div>
    </section>
  );
};

